var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatattach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65331 3.98198L4.35931 6.27698C4.23519 6.40097 4.13672 6.5482 4.06954 6.71026C4.00236 6.87233 3.96778 7.04604 3.96778 7.22148C3.96778 7.39692 4.00236 7.57063 4.06954 7.7327C4.13672 7.89476 4.23519 8.042 4.35931 8.16598V8.16598C4.48329 8.2901 4.63053 8.38857 4.79259 8.45575C4.95466 8.52293 5.12837 8.55751 5.30381 8.55751C5.47925 8.55751 5.65296 8.52293 5.81503 8.45575C5.97709 8.38857 6.12432 8.2901 6.24831 8.16598L9.34831 5.06598C9.84923 4.56474 10.1306 3.88511 10.1306 3.17648C10.1306 2.46785 9.84923 1.78822 9.34831 1.28698C9.10025 1.03871 8.8057 0.841759 8.48149 0.707384C8.15728 0.573009 7.80976 0.503845 7.45881 0.503845C7.10785 0.503845 6.76034 0.573009 6.43613 0.707384C6.11192 0.841759 5.81736 1.03871 5.56931 1.28698L2.19931 4.65698C1.44765 5.40879 1.02539 6.42837 1.02539 7.49148C1.02539 8.55459 1.44765 9.57417 2.19931 10.326V10.326C2.95112 11.0776 3.9707 11.4999 5.03381 11.4999C6.09692 11.4999 7.1165 11.0776 7.86831 10.326L10.9683 7.22598",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatattach);
export default __webpack_public_path__ + "static/media/chatattach.f1d31f6f034b3ab2c3cf8b7fb1b25b75.svg";
export { ForwardRef as ReactComponent };